import type {State} from 'src/reducers';
import type {Template} from 'src/types/templates';

import sortBy from 'lodash/sortBy';
import {createSelector} from 'reselect';


export const getTemplate = (
  state: State,
  id: string,
): Template | null | undefined =>
  // @ts-expect-error - TS7006 - Parameter 'template' implicitly has an 'any' type.
  state.templates.templates.find((template) => template.id === id);

// @ts-expect-error - TS2322 - Type 'OutputParametricSelector<any, undefined, Template[], (res: Template[]) => Template[]>' is not assignable to type '(arg1: any) => Template[]'.
export const selectSortedTemplates: (arg1: State) => Template[] =
  createSelector<State, undefined, Template[], Template[]>(
    (state) => state.templates.templates,
    (templates) => sortBy(templates, 'name'),
  );
